import React from "react";
import { useSelector } from "react-redux";
import { DsLayout } from "shared/constants";
import { RootState } from "state/appStore";

interface ITableRighArrowProps {
    onClick: () => void
}
const TableRighArrow: React.FC<ITableRighArrowProps> = (props): JSX.Element => {
    const { onClick } = props;
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    return (

        <div style={{ color: layoutMode===DsLayout.DARK_MODE?"#C2E9CB":"#004c97", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
            onClick={onClick}>
            <ds-icon
                icon="icon-chevron-right"
                icon-size="large"
                icon-filled={true}
            ></ds-icon>
        </div>);
}
export default TableRighArrow;